import { ref } from "vue";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "toastr/build/toastr.min.css";

export default function (vueApp) {
  // Set global properties
  vueApp.config.globalProperties.$locale = ref(null);
  // Common functions available in all components

  vueApp.config.globalProperties.$Translate = function (key, type = "word") {
    let result = Translator[GetLocalization()][type][key];
    if (result == null && key != null) {
      console.log(key);
      return key;
    }
    return result;
  };

  vueApp.config.globalProperties.$GetLocalization = function () {
    return GetLocalization();
  };

  vueApp.config.globalProperties.$SetLocalization = function (locale) {
    let currentLocale = localStorage.getItem("locale");
    if (currentLocale !== locale) {
      localStorage.setItem("locale", locale);
      let fullUrl = window.location.href;
      if (
        currentLocale == "en" ||
        currentLocale == "" ||
        currentLocale == null
      ) {
        fullUrl = fullUrl.replace("Index.html", "Index-" + locale + ".html");
      } else if (locale == "en") {
        fullUrl = fullUrl.replace(
          "Index-" + currentLocale + ".html",
          "Index.html"
        );
      } else {
        fullUrl = fullUrl.replace(
          "Index-" + currentLocale + ".html",
          "Index-" + locale + ".html"
        );
      }
      location.href = fullUrl;
    }
  };

  vueApp.config.globalProperties.$ConvertToDateFormat = function (item) {
    return moment(item).format('DD-MM-YYYY');
  };

  vueApp.config.globalProperties.$GetWindowDirection = function () {
    return this.$GetLocalization() === "ar" ? "rtl" : "ltr";
  };

  vueApp.config.globalProperties.$DownloadBase64File = function (contentType, base64Data, fileName) {
    // Implement or import this utility function
    DownloadBase64File(contentType, base64Data, fileName);
  };

}

export async function runWithoutBlocking(callback) {
  const originalBlockPage = BlockPage;
  const originalUnBlockPage = UnBlockPage;

  // Override BlockPage and UnBlockPage temporarily
  BlockPage = function () {};
  UnBlockPage = function () {};

  try {
    return await callback();
  } catch (err) {
    throw err;
  } finally {
    // Restore original functions after execution
    BlockPage = originalBlockPage;
    UnBlockPage = originalUnBlockPage;
  }
}